import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext();
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

export const AuthProvider = ({ children }) => {
  const [usuario, setUsuario] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [avisosPendientes, setAvisosPendientes] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const guardado = localStorage.getItem('usuario');
    if (token && guardado) {
      try {
        const u = JSON.parse(guardado);
        setUsuario(u);
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      } catch {}
    }
    setCargando(false);
  }, []);

  // Interceptor: detecta sesión cerrada remotamente o cuenta congelada
  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      res => res,
      err => {
        const codigo = err.response?.data?.codigo;
        if (codigo === 'SESION_CERRADA') {
          doLogout();
          window.alert('Tu sesión ha sido cerrada por el administrador.');
        } else if (codigo === 'CUENTA_CONGELADA') {
          doLogout();
          window.alert(err.response.data.error || 'Tu cuenta ha sido congelada temporalmente.');
        }
        return Promise.reject(err);
      }
    );
    return () => axios.interceptors.response.eject(interceptor);
  }, []);

  // Heartbeat cada 2 minutos para mantener "último visto" actualizado
  useEffect(() => {
    if (!usuario) return;
    const interval = setInterval(() => {
      axios.get(`${API_URL}/auth/ping`).catch(() => {});
    }, 2 * 60 * 1000);
    return () => clearInterval(interval);
  }, [usuario]);

  const doLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('usuario');
    delete axios.defaults.headers.common['Authorization'];
    setUsuario(null);
    setAvisosPendientes([]);
  };

  const cargarAvisos = async () => {
    try {
      const res = await axios.get(`${API_URL}/auth/avisos`);
      if (res.data?.length > 0) setAvisosPendientes(res.data);
    } catch {}
  };

  const login = async (email, password) => {
    const res = await axios.post(`${API_URL}/auth/login`, { email, password });
    const { token, usuario: u } = res.data;
    localStorage.setItem('token', token);
    localStorage.setItem('usuario', JSON.stringify(u));
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    setUsuario(u);
    await cargarAvisos();
    return u;
  };

  const registrar = async (datos) => {
    const res = await axios.post(`${API_URL}/auth/registro`, datos);
    const { token, usuario: u } = res.data;
    localStorage.setItem('token', token);
    localStorage.setItem('usuario', JSON.stringify(u));
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    setUsuario(u);
    await cargarAvisos();
    return u;
  };

  const actualizarUsuario = (u) => {
    setUsuario(u);
    localStorage.setItem('usuario', JSON.stringify(u));
  };

  const logout = doLogout;

  const loginCodigo = async (codigo) => {
    const res = await axios.post(`${API_URL}/auth/login-codigo`, { codigo });
    const { token, usuario: u } = res.data;
    localStorage.setItem('token', token);
    localStorage.setItem('usuario', JSON.stringify(u));
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    setUsuario(u);
    await cargarAvisos();
    return u;
  };

  return (
    <AuthContext.Provider value={{ usuario, cargando, login, registrar, loginCodigo, logout, actualizarUsuario, avisosPendientes, setAvisosPendientes, API_URL }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
